import { setAgentDetails, setAlert, setFormErrors, setFormState} from '../../state/action';
import { useParams } from 'react-router-dom';
import { decryptingUserID } from '../../services/real-star-api/users/decrypt';
import { fetchUserByID } from '../../services/real-star-api/users/user';
import { useContext , useEffect, useState} from 'react';
import FormContext from '../../context/form-context';

const useMainContainer = () => {
    const { dispatch } = useContext(FormContext);
    const { agentID } = useParams();
    const [isMounted, setIsMounted] = useState(false)

    useEffect( () => {
        const getAgentDetails = async () => {
            if (agentID) {
                try {
                    const decryptedAgentID = await decryptingUserID(agentID);
                    const agentResult = await fetchUserByID(decryptedAgentID);
                    dispatch(setAgentDetails(agentResult));
                    setIsMounted(true)

                } catch (agentError) {
                    dispatch(setAlert({
                        show: true,
                        title: `Error: AgentID`,
                        body: `${agentID} does not exist`
                    }));
                }
            }else{
                setIsMounted(true)
            }
        }  
        
        getAgentDetails();
    },[])

    
    return {
        isMounted
    }

}

export default useMainContainer;